import { render, staticRenderFns } from "./AvalonLoader.vue?vue&type=template&id=36951609&scoped=true&"
import script from "./AvalonLoader.vue?vue&type=script&lang=js&"
export * from "./AvalonLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36951609",
  null
  
)

export default component.exports